"use strict";

exports.__esModule = true;
exports.evaluateTrigger = evaluateTrigger;
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _luxon = require("luxon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Evaluate a trigger against input and return true or false depending on
 * whether the trigger matches.
 */
function evaluateTrigger(trigger, input, timestamp, timezone) {
  if (trigger.source === "connectdata") {
    return evaluateConnectdataTrigger(trigger, input);
  }
  if (trigger.source === "scheduled") {
    return evaluateScheduledTrigger(trigger, timestamp, timezone);
  }
}
function evaluateConnectdataTrigger(trigger, input) {
  var source = trigger.source,
    name = trigger.name,
    type = trigger.type,
    operator = trigger.operator,
    value = trigger.value;
  if (source !== input.source || name !== input.name || type !== input.type) {
    return false;
  }
  switch (operator) {
    case "=":
      return compare(value, input.value);
    case ">":
      return Number(input.value) > Number(value);
    case "<":
      return Number(input.value) < Number(value);
    default:
      return false;
  }
}
function evaluateScheduledTrigger(_ref, currentTimestamp, timezone) {
  var value = _ref.value;
  var time = value.time;
  var currentTime = _luxon.DateTime.fromMillis(currentTimestamp, {
    zone: timezone
  });
  switch (value.type) {
    case "daily":
      return checkIfSameTimeAndDate(time, currentTime);
    case "weekly":
      return checkIfSameTimeAndDate(time, currentTime, value.dayOfTheWeek, value.type);
    case "monthly":
      return checkIfSameTimeAndDate(time, currentTime, value.dayOfTheMonth, value.type);
    default:
      return false;
  }
}
function checkIfSameTimeAndDate(timeString, currentTime, dateParam, type) {
  var _timeString$split$map = timeString.split(":").map(Number),
    hour = _timeString$split$map[0],
    minute = _timeString$split$map[1];
  var timeFromString = currentTime.set({
    hour: hour,
    minute: minute,
    second: 0,
    millisecond: 0
  });
  var hour2 = currentTime.hour;
  var minute2 = currentTime.minute;
  var isDayMatch = true;
  if (type === "weekly") {
    var dayOfWeekFromTimestamp = currentTime.weekday;
    isDayMatch = dayOfWeekFromTimestamp === dateParam + 1;
  } else if (type === "monthly") {
    var dayOfMonthFromInput = _luxon.DateTime.fromISO(dateParam).day;
    isDayMatch = currentTime.day === dayOfMonthFromInput;
  }
  return timeFromString.hour === hour2 && timeFromString.minute === minute2 && isDayMatch;
}
function compare(a, b) {
  if (typeof a === typeof b) {
    return (0, _reactFastCompare["default"])(a, b);
  }
  if (typeof a === "string") {
    var anum = parseFloat(a);
    if (!Number.isNaN(anum)) {
      return anum === b;
    }
  }
  if (typeof b === "string") {
    var bnum = parseFloat(b);
    if (!Number.isNaN(bnum)) {
      return bnum === a;
    }
  }
  return false;
}